import { useSelection } from '@components/ArtBoard/Node/hooks'
import cx from 'classnames'
import type React from 'react'
import { useEffect, useState } from 'react'

import { NODE_FRAME } from '@/constants/constants'
import { isContainsOnlySpaces } from '@/helpers'
import type { TreeItemVariants } from '@/types'
import { setPreventPast } from '@/utils/clipboard'
import { replaceArrow } from '@/utils/replaceArrow'
import css from './Input.module.scss'

type Props = {
  id: string
  name: string
  variant: TreeItemVariants
  readOnly?: boolean

  setName?: (name: string) => void
}

const Input: React.FC<Props> = (props) => {
  const [inputValue, setInputValue] = useState(props.name)

  // const dispatch = useDispatch()

  // @todo implement later
  // const firstBlockId = useSelector<AppState, string | undefined>(
  //   ({ blocks }) => blocks.byNodeId[props.id]?.[0]
  // )

  const selection = useSelection(props.id)

  const resize = (ref: HTMLTextAreaElement) => {
    ref.style.height = 'auto'
    ref.style.height = `${ref.scrollHeight}px`
  }

  const onFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    e.target.setSelectionRange(e.target.value.length, e.target.value.length)
  }

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const nodeName = isContainsOnlySpaces(e.target.value) ? ' ' : e.target.value

    const replacedName = replaceArrow(nodeName)

    props.setName?.(replacedName)
    setInputValue(replacedName)

    resize(e.target)
  }

  useEffect(() => {
    setInputValue(replaceArrow(props.name))
  }, [props.name])

  return (
    <textarea
      className={cx(css.container, {
        [css.dashed]: props.variant === NODE_FRAME,
      })}
      rows={1}
      value={inputValue}
      ref={(curr) => {
        if (curr) {
          setTimeout(() => {
            if (!props.readOnly) {
              curr.focus()
            }

            resize(curr)
          })
        }
      }}
      onFocus={onFocus}
      onPaste={(e) => {
        if (setPreventPast(e.clipboardData.getData('text'))) {
          e.preventDefault()
        }
      }}
      onChange={onChange}
      onKeyDown={(e) => {
        if (!e.shiftKey && e.key === 'Enter') {
          e.preventDefault()

          selection.clearSelection()

          // @todo implement later
          // if (firstBlockId) {
          //   dispatch(selectBlock(e as any, const isNeutral = useSelector(migrationProjectSelector.getIsProjectNeutral)))
          // }
        }
      }}
      readOnly={props.readOnly}
      spellCheck={false}
    />
  )
}

export default Input
